var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c(_vm.cms ? 'div' : _vm.tag,{directives:[{name:"reveal",rawName:"v-reveal.once",value:(_vm.reveal ? _vm.revealHandle : false),expression:"reveal ? revealHandle : false",modifiers:{"once":true}}],tag:"component",class:_vm.className,domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }